export const ROLE = "role";
export const RESOURCE_NAME = "resourceName";
export const SCHOOL_ID = "schoolId";
export const REGION_HEAD_ID = "regionHeadId";
export const LAB_TEAMS_ID = "labTeamsId";
export const RELATIONSHIP_MANAGER_ID = "relationshipManagerId";
export const CRM_OPS_STATUS = "crmOpsStatus";
export const COMMENT = "comment";

export const roleOptions = [
  { label: "Region Head", value: "region_head" },
  { label: "Relationship Manager", value: "relationship_manager" },
];

export const crmOpsStatusOptions = [
  { label: "Green", value: "Green" },
  { label: "Yellow", value: "Yellow" },
  { label: "Red", value: "Red" },
];